import { render } from "./FAQFilter.vue?vue&type=template&id=32b09a8c"
import script from "./FAQFilter.vue?vue&type=script&lang=js"
export * from "./FAQFilter.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__